import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import heroIllustration from '../assets/how-it-works/hero-illustration.jpg';

const HowItWorksHeroSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="relative bg-white overflow-hidden" style={{ minHeight: '571px' }}>
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20" style={{ paddingLeft: 'clamp(16px, 8.89vw, 128px)', paddingRight: 'clamp(16px, 8.89vw, 128px)' }}>
        <div className="grid lg:grid-cols-2 gap-12 items-center" style={{ minHeight: '474px' }}>
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-6"
          >
            {/* Headline */}
            <h1 
              className="font-opensans text-[48px] leading-[60px] text-text-primary font-bold"
              style={{ fontVariationSettings: "'wdth' 100" }}
            >
              Your Style, Perfected Digitally
            </h1>

            {/* Description */}
            <p className="font-manrope text-[18px] leading-[28px] text-text-secondary max-w-[568px]">
              Experience the future of custom tailoring with Mater Ji. Our platform connects customers to skilled tailors and empowers businesses to manage their craft with unparalleled efficiency.
            </p>

            {/* CTA Button */}
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => navigate('/auth?mode=signup')}
              className="bg-brand-yellow text-[#704b00] font-manrope font-semibold text-[14px] leading-[22px] px-8 py-3 rounded-full hover:bg-[#ffad0a] transition-all duration-300 flex items-center justify-center gap-2 shadow-md hover:shadow-lg whitespace-nowrap"
              style={{ minWidth: '180px', height: '44px' }}
            >
              Get Started Now
              <ArrowRight className="w-4 h-4" />
            </motion.button>
          </motion.div>

          {/* Right Image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="relative"
          >
            <div className="relative rounded-lg overflow-hidden w-full max-w-[568px]" style={{ height: '379px' }}>
              <div className="absolute inset-0 overflow-hidden pointer-events-none rounded-lg">
                <img 
                  src={heroIllustration} 
                  alt="Tailor with tablet and mannequin" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksHeroSection;
